import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wpejmjn96: FaireProductEntity = {
  token: "p_5wpejmjn96",
  type: "product",
  name: "PW2182 | Linen Round Neck Short Sleeve Midi Dress",
  brandToken: "b_dr2g2r45g7",
  brandName: "a.ren",
  imageUrl:
    "https://cdn.faire.com/fastly/b96b2db74cf19e0fb9c38091ddff6b1df017d162d5ca3653a6e87a2c82fbfda9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb627727ff350ddf8ef6e2eeb4912195f28f6d8fcdf775a5c992d3b3e5ef4ca3.jpeg",
    "https://cdn.faire.com/fastly/2f9590372eea74d0f9a44ab513301d78f4fa14ff4eedb51283ae7dae200b8a1c.jpeg",
    "https://cdn.faire.com/fastly/e2006bf88aec850da0e886326760aa19e0f9563f94c6fbaccb511afdab2d4ec6.jpeg",
  ],
  priceDollars: 348,
  description:
    "Woven Tencel Polyester Acetic Acid Linen Pintuck Round Neck Short Sleeve Midi Dress With Back Zipper And Cotton Lining\n\nHand Wash Cold With Like Colors, Do Not Bleach, Hang To Dry, Do Not Iron",
  tags: [],
  msrpDollars: 720,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:56.161Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
